import NavBar from "../components/NavBar";
import BackgroundImage from "../components/BackgroundImage";
import TransLink from "../components/TransLink";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { trackCTA } from "../utils/eventTracker";
import Footer from "../components/Footer";

export default function About() {
  const { t } = useTranslation();

  return (
    <div className="page-wrapper">
      <BackgroundImage />
      <NavBar />
      <div className="transparency-wrapper">
        <div className="secondary-page-wrapper">
          <div className="section-text-centered-wrapper-quote breathe">
            <div className="section-title-centered neon-glow">
              {t("aboutTitle1")}
            </div>
            <div className="section-subtitle-centered cyan">
              {t("aboutTitle2")}
            </div>
          </div>

          <div className="about-split-block">
            <div className="about-text-side">
              <p>{t("aboutIntroParagraph")}</p>
            </div>

            <div className="about-image-side">
              <img
                src="/me.webp"
                alt="Damián Vallejo"
                className="about-me-photo"
              />
            </div>
          </div>

          <TransLink
            t="aboutEducationParagraph1"
            textStyle="section-text-secondary-about-me"
            linkStyle="project-link"
          />
          <br />
          <TransLink
            t="aboutEducationParagraph2"
            textStyle="section-text-secondary-about-me"
            linkStyle="project-link"
          />

          <div className="cta-button-secondary-wrapper">
            <Link
              to="/quote"
              className="cta-button-secondary"
              onClick={() => trackCTA("about-cta-1")}
            >
              {t("aboutCTA1")}
            </Link>
          </div>

          <div className="section-text-secondary-about-me">
            <p>{t("aboutServiceParagraph1")}</p>
            <p>{t("aboutServiceParagraph2")}</p>
            <p>{t("aboutServiceParagraph3")}</p>
          </div>

          <div className="cta-button-secondary-wrapper">
            <Link
              to="/quote"
              className="cta-button-secondary"
              onClick={() => trackCTA("about-cta-bottom")}
            >
              {t("aboutCTA2")}
            </Link>
          </div>
          <div className="bottom-space"></div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
